export const QF_DEFAULT_VALUES_MOCK = {
    name: 'RbR Default Values Flow',
    compiledFlowBlocks: {
        '9aff592e-6bf7-4912-b7e4-fc6a4becdcfb': {
            id: '530036e2-2458-4370-9c33-72879265ad76',
            name: 'SECTION',
            blockType: 'SECTION_BLOCK',
            isVirtual: true,
            flowBlockId: '9aff592e-6bf7-4912-b7e4-fc6a4becdcfb',
            flowId: '<flow-mongo-db-record-id>',
            inputParameters: [],
            outputParameters: []
        },
        'a39aec86-6fa1-45ee-92e1-a20ce8005289': {
            id: '2c18dfbe-eeda-4d41-b6cb-a38bf36b1587',
            name: 'ACCORDION',
            blockType: 'SUB_SECTION_BLOCK',
            isVirtual: true,
            flowBlockId: 'a39aec86-6fa1-45ee-92e1-a20ce8005289',
            flowId: '<flow-mongo-db-record-id>',
            inputParameters: [],
            outputParameters: []
        },
        '8784f6ae-39c4-479a-a18b-6acfe84648a9': {
            id: '06a4b78c-db3c-4ac4-89e6-a524c6ceec1b',
            name: 'DEFAULTS',
            blockType: 'QUESTION_BLOCK',
            template: {
                type: 'MULTI_SLOT_QUESTION_TEMPLATE',
                layout: {
                    breakpoints: {
                        xs: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        sm: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        md: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        lg: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        xl: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        }
                    }
                },
                slots: [
                    {
                        type: 'NUMERIC_INPUT_SLOT',
                        id: '0bf12b5e-73be-4192-bf96-73b6d0f9ea63',
                        outputParameter: 'project.building.buildingLevelHeight',
                        outputParameterType: 'NUMBER',
                        validations: [
                            {
                                id: '0dcae275-7282-4b7f-9ee9-7d3941f92b72',
                                logicalCondition: {
                                    '<=': [
                                        {
                                            flexiPath: [
                                                {
                                                    originalPath: 'project.building.buildingLevelHeight',
                                                    tokens: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'building'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'buildingLevelHeight'
                                                        }
                                                    ],
                                                    dynamicSlots: []
                                                }
                                            ]
                                        },
                                        15
                                    ]
                                },
                                errorMessageKey:
                                    'QUESTION_FLOW.QUESTIONS.06a4b78c-db3c-4ac4-89e6-a524c6ceec1b.SLOTS.0bf12b5e-73be-4192-bf96-73b6d0f9ea63.VALIDATIONS.0dcae275-7282-4b7f-9ee9-7d3941f92b72.ERROR_MESSAGE'
                            },
                            {
                                id: 'f158741b-4a05-43db-acdc-f34279248602',
                                logicalCondition: {
                                    '>=': [
                                        {
                                            flexiPath: [
                                                {
                                                    originalPath: 'project.building.buildingLevelHeight',
                                                    tokens: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'building'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'buildingLevelHeight'
                                                        }
                                                    ],
                                                    dynamicSlots: []
                                                }
                                            ]
                                        },
                                        1.5
                                    ]
                                },
                                errorMessageKey:
                                    'QUESTION_FLOW.QUESTIONS.06a4b78c-db3c-4ac4-89e6-a524c6ceec1b.SLOTS.0bf12b5e-73be-4192-bf96-73b6d0f9ea63.VALIDATIONS.f158741b-4a05-43db-acdc-f34279248602.ERROR_MESSAGE'
                            }
                        ],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        dataFormat: '4.2',
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        suffixKey:
                            'QUESTION_FLOW.QUESTIONS.06a4b78c-db3c-4ac4-89e6-a524c6ceec1b.SLOTS.0bf12b5e-73be-4192-bf96-73b6d0f9ea63.SUFFIX.CONTENT',
                        pathPlaceholders: [],
                        titleKey:
                            'QUESTION_FLOW.QUESTIONS.06a4b78c-db3c-4ac4-89e6-a524c6ceec1b.SLOTS.0bf12b5e-73be-4192-bf96-73b6d0f9ea63.TITLE',
                        compiledOutputParameter: {
                            originalPath: 'project.building.buildingLevelHeight',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'buildingLevelHeight'
                                }
                            ],
                            dynamicSlots: []
                        }
                    },
                    {
                        type: 'DROP_DOWN_SLOT',
                        id: 'fa79aa42-50d5-4903-89ca-793d7ce435a6',
                        outputParameter: 'project.building.standardTypeOfWindow',
                        outputParameterType: 'STRING',
                        validations: [],
                        dataSource: 'WINDOW_TYPES',
                        dataSourceMapping: {
                            flexiPath: [
                                {
                                    originalPath: 'dataSources.WINDOW_TYPES.items',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'dataSources'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'WINDOW_TYPES'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'items'
                                        }
                                    ],
                                    dynamicSlots: []
                                }
                            ]
                        },
                        dataSourceSelectionOutput: 'dataSources.WINDOW_TYPES.selectedItem',
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        labelKey: 'DATA_SOURCES.WINDOW_TYPES.{{value}}.LABEL',
                        pathPlaceholders: [],
                        titleKey:
                            'QUESTION_FLOW.QUESTIONS.06a4b78c-db3c-4ac4-89e6-a524c6ceec1b.SLOTS.fa79aa42-50d5-4903-89ca-793d7ce435a6.TITLE',
                        compiledOutputParameter: {
                            originalPath: 'project.building.standardTypeOfWindow',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'standardTypeOfWindow'
                                }
                            ],
                            dynamicSlots: []
                        }
                    },
                    {
                        type: 'DROP_DOWN_SLOT',
                        id: '38f2aaec-1453-4e13-aa1c-488ab98530ac',
                        outputParameter: 'project.building.standardTypeOfSunProtection',
                        outputParameterType: 'STRING',
                        validations: [],
                        dataSource: 'WINDOW_SUN_PROTECTION_TYPES',
                        dataSourceMapping: {
                            flexiPath: [
                                {
                                    originalPath: 'dataSources.WINDOW_SUN_PROTECTION_TYPES.items',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'dataSources'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'WINDOW_SUN_PROTECTION_TYPES'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'items'
                                        }
                                    ],
                                    dynamicSlots: []
                                }
                            ]
                        },
                        dataSourceSelectionOutput: 'dataSources.WINDOW_SUN_PROTECTION_TYPES.selectedItem',
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        labelKey: 'DATA_SOURCES.WINDOW_SUN_PROTECTION_TYPES.{{value}}.LABEL',
                        pathPlaceholders: [],
                        titleKey:
                            'QUESTION_FLOW.QUESTIONS.06a4b78c-db3c-4ac4-89e6-a524c6ceec1b.SLOTS.38f2aaec-1453-4e13-aa1c-488ab98530ac.TITLE',
                        compiledOutputParameter: {
                            originalPath: 'project.building.standardTypeOfSunProtection',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'standardTypeOfSunProtection'
                                }
                            ],
                            dynamicSlots: []
                        }
                    }
                ]
            },
            validations: [],
            headerKey: 'QUESTION_FLOW.QUESTIONS.06a4b78c-db3c-4ac4-89e6-a524c6ceec1b.HEADER',
            flowBlockId: '8784f6ae-39c4-479a-a18b-6acfe84648a9',
            flowId: '<flow-mongo-db-record-id>',
            inputParameters: [
                {
                    parameter: 'dataSources.WINDOW_TYPES.items',
                    type: 'ARRAY'
                },
                {
                    parameter: 'dataSources.WINDOW_TYPES',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.WINDOW_SUN_PROTECTION_TYPES.items',
                    type: 'ARRAY'
                },
                {
                    parameter: 'dataSources.WINDOW_SUN_PROTECTION_TYPES',
                    type: 'OBJECT'
                }
            ],
            outputParameters: [
                {
                    parameter: 'project.building.buildingLevelHeight',
                    type: 'NUMBER'
                },
                {
                    parameter: 'project.building.standardTypeOfWindow',
                    type: 'STRING'
                },
                {
                    parameter: 'dataSources.WINDOW_TYPES',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.WINDOW_TYPES.selectedItem',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.WINDOW_TYPES.items',
                    type: 'ARRAY'
                },
                {
                    parameter: 'project.building.standardTypeOfSunProtection',
                    type: 'STRING'
                },
                {
                    parameter: 'dataSources.WINDOW_SUN_PROTECTION_TYPES',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.WINDOW_SUN_PROTECTION_TYPES.selectedItem',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.WINDOW_SUN_PROTECTION_TYPES.items',
                    type: 'ARRAY'
                }
            ]
        }
    },
    flow: {
        _id: '<flow-mongo-db-record-id>',
        diagram: '<diagram-mongo-db-record-id>',
        version: {
            currentVersion: 1,
            changeHistory: []
        },
        type: 'QUESTION_FLOW',
        area: 'MAIN_QUESTION_FLOW',
        blocks: [
            {
                id: '9aff592e-6bf7-4912-b7e4-fc6a4becdcfb',
                definitionId: '530036e2-2458-4370-9c33-72879265ad76',
                order: 1,
                childIds: ['a39aec86-6fa1-45ee-92e1-a20ce8005289'],
                slots: []
            },
            {
                id: 'a39aec86-6fa1-45ee-92e1-a20ce8005289',
                definitionId: '2c18dfbe-eeda-4d41-b6cb-a38bf36b1587',
                order: 2,
                parentId: '9aff592e-6bf7-4912-b7e4-fc6a4becdcfb',
                childIds: ['8784f6ae-39c4-479a-a18b-6acfe84648a9'],
                slots: []
            },
            {
                id: '8784f6ae-39c4-479a-a18b-6acfe84648a9',
                definitionId: '06a4b78c-db3c-4ac4-89e6-a524c6ceec1b',
                order: 3,
                parentId: 'a39aec86-6fa1-45ee-92e1-a20ce8005289',
                slots: [
                    {
                        slotId: '0bf12b5e-73be-4192-bf96-73b6d0f9ea63',
                        compiledPath: {
                            originalPath: 'project.building.buildingLevelHeight',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'buildingLevelHeight'
                                }
                            ],
                            dynamicSlots: []
                        },
                        pathPlaceholders: []
                    },
                    {
                        slotId: 'fa79aa42-50d5-4903-89ca-793d7ce435a6',
                        compiledPath: {
                            originalPath: 'project.building.standardTypeOfWindow',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'standardTypeOfWindow'
                                }
                            ],
                            dynamicSlots: []
                        },
                        pathPlaceholders: []
                    },
                    {
                        slotId: '38f2aaec-1453-4e13-aa1c-488ab98530ac',
                        compiledPath: {
                            originalPath: 'project.building.standardTypeOfSunProtection',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'standardTypeOfSunProtection'
                                }
                            ],
                            dynamicSlots: []
                        },
                        pathPlaceholders: []
                    }
                ],
                outputPaths: ['1e7d6a0b-4a41-434a-b7b5-7d9a7e7e5a92']
            },
            {
                id: '1e7d6a0b-4a41-434a-b7b5-7d9a7e7e5a92',
                definitionId: '0',
                order: 4,
                slots: [],
                inputPaths: ['8784f6ae-39c4-479a-a18b-6acfe84648a9']
            }
        ],
        startingPoint: {
            blockId: '8784f6ae-39c4-479a-a18b-6acfe84648a9',
            subsectionId: 'a39aec86-6fa1-45ee-92e1-a20ce8005289',
            sectionId: '9aff592e-6bf7-4912-b7e4-fc6a4becdcfb'
        }
    },
    version: '2.0.0'
};
